$(function() {

    // @vars -----------------------------------------------------------------------------------------------------------
    var $autocompletes = $('.autocomplete');

    // @initializations ------------------------------------------------------------------------------------------------
    if ($autocompletes.length) {
        $autocompletes.each(function(i, child) {
            var $child = $(child);
            var data = {
                action: 'get-autocomplete-options',
                handle: $child.data('list-handle')
            };
            $child.autocomplete({
                delay: 0,
                source: function(request, response) {
                    data.term = request.term;
                    getAutocompleteOptions(data)
                        .done(function(json) {
                            response(json);
                        });
                },
                minLength: 0
            });
        });
    }

    // @functions ------------------------------------------------------------------------------------------------------
    $(document).on('submit', 'form.tpol_access_code', function(e){
        $('input[type=submit], button').attr('disabled','disabled');
    });

    function getAutocompleteOptions(data) {
        return $.ajax({
            url: CCM_REL + '/index.php/tools/packages/access_code_automation/ajax.php',
            data: data,
            type: 'GET',
            dataType: 'json'
        });
    }
});
